import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
  selector: 'app-header-button',
  template: `
    <button mat-flat-button (click)="onClick($event)" [attr.aria-label]="caption" class="h-btn">
      <mat-icon
        *ngIf="icon"
        [svgIcon]="icon"
        [matBadge]="badgeCount"
        matBadgeSize="small"
        [matBadgeHidden]="!badgeCount || badgeCount <= 0"
        aria-hidden="false"
      />
      <span class="caption">{{ caption }}</span>
    </button>
  `,
  styleUrls: ['./header-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatBadgeModule],
})
export class HeaderButtonComponent {
  @Input({ required: true }) caption: string;
  @Input({ required: true }) icon: string;
  @Input() badgeCount?: number;
  @Output() buttonClick = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent) {
    this.buttonClick.emit(event);
  }
}
